window.PopupEvents = {


    init(){

        const popup =
        PopupController.popup;


        if(!popup) return;



        /*
        ============================
        Botón cerrar
        ============================
        */


        const closeButton =
        popup.querySelector(
            ".maisa-popup__close"
        );


        if(closeButton){

            closeButton.addEventListener(
                "click",
                () => {

                    PopupController.hide();

                }
            );

        }



        /*
        ============================
        Overlay
        ============================
        */


        const overlay =
        popup.querySelector(
            ".maisa-popup__overlay"
        );


        if(overlay){

            overlay.addEventListener(
                "click",
                (event)=>{


                    if(event.target === overlay){

                        PopupController.hide();

                    }

                }
            );

        }



        /*
        ============================
        ESC
        ============================
        */


        document.addEventListener(
            "keydown",
            (event)=>{


                if(
                    event.key === "Escape"
                ){

                    PopupController.hide();

                }


            }
        );



        /*
        ============================
        Trigger 20 segundos
        ============================
        */


        setTimeout(()=>{


            if(
                PopupStorage.canShow()
                &&
                !PopupStorage.isSubscribed()
            ){

                PopupController.openOnce();

            }


        },20000);




        /*
        ============================
        Trigger scroll 40%
        ============================
        */


        window.addEventListener(
            "scroll",
            ()=>{


                const scrollPercent =
                (
                    window.scrollY +
                    window.innerHeight
                )
                /
                document.documentElement.scrollHeight
                *
                100;



                if(
                    scrollPercent >= 40
                ){

                    if(
                        PopupStorage.canShow()
                        &&
                        !PopupStorage.isSubscribed()
                    ){

                        PopupController.openOnce();

                    }

                }


            },
            {
                passive:true
            }
        );


    }


};